// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header_dk[data-v-90f5b040] {\n  text-align: center;\n  padding-top: 0px;\n  position: fixed;\n  left: 50%;\n  transform: translate(-50%);\n  top: 0;\n}\n.client_logo[data-v-90f5b040] {\n  max-width: 475px;\n}\n.ContainerImage[data-v-90f5b040] {\n  margin: 120px auto;\n  margin-bottom: 157px;\n}\n", ""]);
// Exports
module.exports = exports;
